import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { IAppRootState } from 'src/app/core/store';

import { entityOriginalReducer } from './entity.reducer';
import { EntityOriginalSliceState, EntitySliceKey } from './entity.state';

export const EntityFeatureKey = 'Entity';

export interface EntityFeatureState {
	[EntitySliceKey]: EntityOriginalSliceState;
}

export interface EntityRootState extends IAppRootState {
	[EntityFeatureKey]: EntityFeatureState;
}

export const featureSelector =
	createFeatureSelector<EntityFeatureState>(EntityFeatureKey);

export const entityReducers: ActionReducerMap<EntityFeatureState> = {
	[EntitySliceKey]: entityOriginalReducer,
};
